
import { HttpClient } from "@angular/common/http";
import { Injector, Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { ApiService } from "../base-service/api.service";

@Injectable()
export class EmailConfigService extends ApiService<any, any, any> {
    urlPath: string = 'configurations';

    constructor(Http: HttpClient, Injector: Injector, private http: Http) {
        super(Http, Injector);
    }
}